import dayjs from "dayjs";
import { formatDate } from "../../utils/formatters";
import { InputField, type InputFieldProps } from "./InputField";
export const formatDefaultDate = (value: string): string => {
  return dayjs(value).format("MM/DD/YYYY");
};
export const DateTextField = (props: InputFieldProps) => {
  return <InputField formatInput={formatDate} inputMode="numeric" keyboardType="number-pad" maxLength={10} placeholder="MM/DD/YYYY" {...props} data-sentry-element="InputField" data-sentry-component="DateTextField" data-sentry-source-file="DateTextField.tsx" />;
};